// extracted by mini-css-extract-plugin
module.exports = {"ref-info-box":"reference-info-box_ref-info-box__pmbDS","info-box-button-col":"reference-info-box_info-box-button-col__QclDX","hidden":"reference-info-box_hidden__uCbvc"};